<div  class="update-container">
  <div class="update-ask" *ngIf="!isAskedForUpdate && !isNotDonated && !updateOnly">
    <div class="update-ask-txt" >
      {{ 'Stories.updates.feelFreeUpdate1' | translatePipe | async}} <span class="update-c-name">{{fundraiser?.campaigner?.full_name}}</span> {{ 'Stories.updates.feelFreeUpdate2' | translatePipe | async}}
    </div>
    <button type="button" class="upadte-ask-btn" (click)="askUpdateClickListner($event.target)" mat-raised-button>
      <app-ask-update [isDonated]="isDonated" (isAskedForUpdate)="getIsAskedForUpdate($event)" (isNotDonated)="getIsNotDonated($event)">
      </app-ask-update>
    </button>
  </div>
  <div class="update-ask" *ngIf="!isAskedForUpdate && isNotDonated">
    <div class="update-ask-txt" *ngIf="isNotDonated">Only Contributors can ask for Update</div>
    <app-donate-now *ngIf="!isFundraiserEnded && campaign!=='stories'" class="update-donate" label="Contribute Now"
                    [fundraiser]="fundraiser" [position]="13">
    </app-donate-now>
  </div>
  <div class="update-asked" *ngIf="isAskedForUpdate">Your request for an update has been sent to the campaigner successfully!</div>
  <div #updateContainer *ngFor="let update of updates?.data; let i = index" class="individual-updates">
    <div class="heading-update-page" *ngIf="update?.id == latestUpdate && pageName==='updatesPage'">{{ 'Stories.updates.latestUpdate' | translatePipe | async}}</div>
    <div class="update-post">
      <div class="update-heading" *ngIf="i==0">{{ 'Stories.updates.latestUpdate' | translatePipe | async}}</div>
      <div class="update-type-container">
        <div class="update-type">
          <mat-icon class="update-icon" [ngStyle]="{'-webkit-text-fill-color':getColor(update.update_type)}" [ngClass]="getUpdateTypeIcon(update.update_type)"></mat-icon>
          <div [ngStyle]="{'color':getColor(update.update_type)}" class="update-type-label">{{getUpdateTypeLabel(update.update_type)}}</div>
        </div>
        <div [ngStyle]="{'background-color':getColor(update.update_type)}" class="update-number">#{{(updates?.total - updates?.from + 1) - i}}</div>
      </div>
      <div class="update-title">{{setTitleCase(update.update_title)}}</div>
      <div class="donor-container">
        <app-avatar [size]="'40px'" [name]="update?.owner?.full_name" [image]="update?.owner?.avtar?.cdn_path"></app-avatar>
        <div class="name-n-time">
          <span class="name-label">{{update?.owner?.full_name}}</span>
          <span *ngIf="update?.creation_time" class="post-date-time">{{update?.creation_time | dayjs:'to'}}</span>
        </div>
      </div>
      <div class="update-vr-line"></div>

      <div [ngClass]="showMoreBtn?'colapsed-update':'opened-update'">
        <app-inner-templater [innerHtml]="update.update_text | textEllipsis: showMoreBtn : (isMobile?200:500)" [count]="i" class="update-content"></app-inner-templater>
        <div *ngIf="showMoreBtn" class="empty-shadow">&nbsp;</div>
        <div *ngIf="showMoreBtn" class="read-more">
          <button mat-button (click)="readMoreClicked()">Read More</button>
        </div>
      </div>

      <div *ngIf="!updateOnly && variablesService.social && !showSocialShare" class="update-fb">
        <div class="update-fb-text">{{ 'Stories.updates.fbShare' | translatePipe | async}}</div>
        <app-fb-share [label]="'Share'" [campaign_url]="updates?.data?.facebook?.campaign_url"
                      [utm_params]="updates?.data?.facebook?.utm_params" [fundraiser]="fundraiser"
                      class="facebook-share-component" [position]="4">
        </app-fb-share>
        <app-whatsapp-share *ngIf="pageName == 'updatesPage'" class="whatsapp-share-component"
                            [label]="updates?.data?.whatsapp?.label" [count]="updates?.data?.whatsapp?.count" [customTag]="customTag"
                            [basicInfo]="basicInfo" [fundraiser]="fundraiser" [isFundraiserEnded]="isFundraiserEnded">
        </app-whatsapp-share>
      </div>
      <app-updates-social-share *ngIf="showSocialShare"></app-updates-social-share>
      <div *ngIf="(variablesService.social || userdata) && likes" class="update-fb-stats">
        <mat-icon class="icon-linecomment up-fb-icon align-icon"></mat-icon>&nbsp;<span (click)="commentCountClick(update)" class="comments">{{getCommentLength(update?.comments)}} {{getCommentLength(update?.comments) > 1 ? "Comments" : "Comment"}}</span>
        <div class="update-hr-line">|</div>
        <div class="fb-reactions">
          <button type="button" (click)="reactOnUpdate(update)" mat-icon-button>
            <mat-icon [ngClass]="getUpdateTypeReaction(update?.update_type, update?.user_liked?.status)" [ngStyle]="{'-webkit-text-fill-color':getColor(update.update_type)}" class="up-fb-icon"></mat-icon>
          </button>
          <span>&nbsp;{{update?.likes_count?.count}}</span>
        </div>
      </div>

      <!-- Show more button -->
      <!-- <div *ngIf="showMoreBtn" class="show-more-btn-contianer">
        <button color="primary" mat-button (click)="showMoreBtn=false">Read More</button>
      </div> -->
    </div>
    <app-comment-card *ngIf="!updateOnly && showComments" class="update-comment" [comments]="update?.comments" [update]="update" [reactionType]="getUpdateTypeReaction(update?.update_type, update?.user_liked?.status)" [updateTypeColor]="getColor(update.update_type)"
                      [header]="false" origin="update" [count]="update?.likes_count?.count" [pageName]="pageName" [campaignId]="campaignId" [updateId]="update.id" [postCommentLabel]="update?.comments?.placeholder"
                      (commentPosted)="isCommentPosted($event)" (isCommentVisible)="isCommentVisible($event)" (updateReact)="reactOnUpdate(update)" [showCommentList]="update?.showCommentList">
    </app-comment-card>
    <div *ngIf="pageName=='campaing' && (i+1)<updates.data.length" class="divider"></div>
  </div>


  <app-offer-card *ngIf="showOffer && userdata && !userdata?.listsubscriptions?.medical && currency==='INR' && !actRoute?.snapshot?.queryParams?.offer" [config]="{offerAmount: 100, currency: 'INR'}"></app-offer-card>

  <div class="read-more-updates" *ngIf="viewMore && updates.next_page_url">
    <div class="seperator"></div>
    <div class="read-more-text" (click)="loadUpdate()">
      Read Previous Updates <mat-icon class="arrow-icon">arrow_downward</mat-icon>
    </div>
  </div>

  <div *ngIf="currency && config?.sipPitch" inViewport (inViewportAction)="sipPitchVisible($event)" id="donation-form" class="sip-dark-card offer-scroll">
    <app-module-loader moduleId="sip-pitch-card-v4" selector="app-sip-pitch-card-v4" [load]="currency && config?.sipPitch"
                      [inputs]="{config: {origin: 'uip', currency: currency, update_id: actRoute?.snapshot?.queryParams?.update_id, userdata: userdata}}">
    </app-module-loader>
  </div>

</div>

<ng-template #loginPopupTemp>
  <app-module-loader moduleId="login-popup" selector="app-login-popup" [load]="true"></app-module-loader>
</ng-template>
